export default "__VITE_ASSET__BQkwqT43__"